import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';

import { StaticRoutePaths, RoutePaths } from '../Common/ClientRoutes';
import { UserRole } from '../Common/UserRole';
import Svgs from '../Common/Svgs';
import DragDropList from '../Common/components/DragDropList';
import { todayDayAbbreviation } from '../Common/Helpers';
import { MainBtn } from '../Common/form/Elements-export';
import localStorage from '../Common/LocalStorage';
import { translations } from '../Common/Translations';

import { getServicesList, editPharmacy } from './epics-pharmacies';
// import { SingleService } from './components/Single-service';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

class PharmacyDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pharmacyId: this.props.pharmacyDetails.id,
            loadingSpinner: false,
            shopURL: this.props.pharmacyDetails.shopURL ? this.props.pharmacyDetails.shopURL : '',
            editShopURL: !this.props.pharmacyDetails.shopURL,
            servicesList: [],
            EN_service: [],
            DE_service: [],
            FR_service: [],
            IT_service: [],
            validation: {
                shopURL: ''
            }
        };
    }

    // generateServicesList = () => {
    //     return (this.state.servicesList || []).map(service => {
    //         return (
    //             <SingleService
    //                 key={service.id}
    //                 serviceId={service.id}
    //                 title={service.title}
    //                 pharmacyId={this.props.pharmacyDetails.id}
    //                 appearance={this.props.pharmacyDetails.appearance}
    //             />
    //         );
    //     });
    // };

    fetchTodayWorkTime = () => {
        let todayWorkTimeArray = this.props.pharmacyDetails.workTime.weekDays[todayDayAbbreviation()];

        if (todayWorkTimeArray.length === 0) {
            return 'Day Off';
        } else if (todayWorkTimeArray.length === 1) {
            return 'from ' + todayWorkTimeArray[0].from + ' to ' + todayWorkTimeArray[0].to;
        } else if (todayWorkTimeArray.length === 2) {
            return (
                'from ' +
                todayWorkTimeArray[0].from +
                ' to ' +
                todayWorkTimeArray[0].to +
                ' and from ' +
                todayWorkTimeArray[1].from +
                ' to ' +
                todayWorkTimeArray[1].to
            );
        }
    };

    update = type => e => {
        this.setState({ ...this.state, [type]: e.target.value });
    };

    editShopURLHandler = () => {
        this.setState({ ...this.state, editShopURL: true });
    };

    saveShopURLHandler = () => {
        if (this.state.shopURL.trim() !== '') {
            let data = {
                shopURL: this.state.shopURL
            };

            let newValidation = { ...this.state.validation };
            newValidation.shopURL = '';
            this.setState({ ...this.state, loadingSpinner: true, validation: newValidation });
            editPharmacy(data, this.props.pharmacyDetails.id)
                .then(() => {
                    this.setState({ ...this.state, loadingSpinner: false, editShopURL: false });
                })
                .catch(() => {
                    this.setState({ ...this.state, loadingSpinner: false });
                });
        } else {
            let newValidation = { ...this.state.validation };
            newValidation.shopURL = 'Please provide shop URL.';
            this.setState({ ...this.state, validation: newValidation });
        }
    };

    generateErrorsMessages = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    componentDidMount = () => {
        if (this.props.pharmacyDetails.serviceType === 'services') {
            getServicesList(this.props.pharmacyDetails.id)
                .then(res => {
                    this.setState({
                        ...this.state,
                        EN_service: res[0],
                        DE_service: res[1],
                        FR_service: res[2],
                        IT_service: res[3]
                    });
                })
                .catch(() => {
                    this.setState({
                        ...this.state,
                        EN_service: [],
                        DE_service: [],
                        FR_service: [],
                        IT_service: []
                    });
                });
        }
    };

    generateShopURL = link => {
        const linkToArray = link.split('//');
        let url = '';
        if (linkToArray.length === 2) {
            url = linkToArray[0] + '//' + linkToArray[1];
            return url;
        }
        if (linkToArray.length < 2) {
            url = 'http://' + linkToArray.join('');
            return url;
        }
    };

    generateShopLayout = (loading, shopURL) => {
        return (
            <div className="row">
                <div className="col-12 formInput">
                    <label>{strings.Shop_url}</label>
                    {loading ? (
                        <div className="col-11 white-bg px-5 text-center p-3">
                            <i className="fa fa-spinner fa-spin fa-3x" style={{ color: '#858585' }} />
                        </div>
                    ) : (
                        <div>
                            {shopURL ? (
                                <div>
                                    <input
                                        onChange={this.update('shopURL')}
                                        type="text"
                                        placeholder={strings.shop_input_placeholder}
                                        value={this.state.shopURL}
                                    />
                                    <div className="col-12">{this.generateErrorsMessages(this.state.validation.shopURL)}</div>
                                    <MainBtn
                                        onclick={this.saveShopURLHandler}
                                        title={strings.Save_shop_url}
                                        extraClasses="qf-blue-btn rightFloat mt-3"
                                    />
                                </div>
                            ) : (
                                <div className="qf-shop-link">
                                    <a href={this.generateShopURL(this.state.shopURL)} target="_Blank">
                                        {this.state.shopURL}
                                    </a>
                                    <i className="fa fa-pencil-square-o ml-2" onClick={this.editShopURLHandler} />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    generateServiceLayout = () => {
        return (
            <div className="serviceWrapper">
                <div className="row mb-4">
                    <div className="col-6">
                        <div className="color-dark-gray mb-2 qf-service-title">{strings.Services}</div>
                    </div>
                    <div className="col-6" style={{ textAlign: 'right' }}>
                        <Link
                            className="qf-blue-btn"
                            to={{
                                pathname: RoutePaths.ADD_PHARMACY_SERVICE(this.props.pharmacyDetails.id),
                                state: { appearance: { ...this.props.pharmacyDetails.appearance } }
                            }}
                        >
                            {strings.Add_Services}
                            <i className="fa fa-chevron-right ml-2" />
                        </Link>
                    </div>
                </div>
                <DragDropList
                    pharmacyId={this.state.pharmacyId}
                    language={strings.english}
                    services={this.state.EN_service}
                    appearance={this.props.pharmacyDetails.appearance}
                />
                <DragDropList
                    pharmacyId={this.state.pharmacyId}
                    language={strings.deutsch}
                    services={this.state.DE_service}
                    appearance={this.props.pharmacyDetails.appearance}
                />
                <DragDropList
                    pharmacyId={this.state.pharmacyId}
                    language={strings.french}
                    services={this.state.FR_service}
                    appearance={this.props.pharmacyDetails.appearance}
                />
                <DragDropList
                    pharmacyId={this.state.pharmacyId}
                    language={strings.italian}
                    services={this.state.IT_service}
                    appearance={this.props.pharmacyDetails.appearance}
                />
            </div>
        );
    };

    render() {
        this.generateShopURL(this.state.shopURL);
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.pharmacy}</span>
                    </div>

                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-info-circle mr-2" />
                                    {strings.Pharmacy_info}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                {this.props.userStatus === UserRole.PHARMACY_MANAGER ? (
                                    <Link to={StaticRoutePaths.HOME} className="qf-back-btn">
                                        <i className="fa fa-chevron-left" />
                                        {strings.back}
                                    </Link>
                                ) : (
                                    <Link to={StaticRoutePaths.PHARMACIES} className="qf-back-btn">
                                        <i className="fa fa-chevron-left" />
                                        {strings.back}
                                    </Link>
                                )}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-5">
                                <div className="row">
                                    <div className="col-12 color-dark-gray">{strings.Pharmacy_name}</div>
                                    <div className="col-12 color-light-blue mb-1 qf-big-text">
                                        {this.props.pharmacyDetails.name ? this.props.pharmacyDetails.name : 'not set'}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 color-dark-gray">{strings.company_name}</div>
                                    <div className="col-12 color-light-blue mb-1 qf-big-text">
                                        {this.props.pharmacyDetails.company ? this.props.pharmacyDetails.company.name : 'not set'}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 color-dark-gray">{strings.address}</div>
                                    <div className="col-12 color-light-blue mb-1 qf-big-text">
                                        {this.props.pharmacyDetails.address.name}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 color-dark-gray">{strings.phone}</div>
                                    <div className="col-12 color-light-blue mb-1 qf-big-text">{this.props.pharmacyDetails.phone}</div>
                                </div>

                                <div className="row">
                                    <div className="col-12 color-dark-gray">{strings.Email}</div>
                                    <div className="col-12 color-light-blue mb-1 qf-big-text">{this.props.pharmacyDetails.email}</div>
                                </div>

                                <div className="row">
                                    <div className="col-12 color-dark-gray">{strings.Manager}</div>
                                    <div className="col-12 color-light-blue mb-1 qf-big-text">
                                        {this.props.pharmacyDetails.manager ? this.props.pharmacyDetails.manager.names : 'not set'}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 color-dark-gray">{strings.Work_time}</div>
                                    <div className="col-12 color-light-blue mb-4 qf-big-text">{this.fetchTodayWorkTime()}</div>
                                </div>

                                <div className="row">
                                    <div className="col-12 qf-mb-30">
                                        <Link className="qf-blue-btn" to={RoutePaths.EDIT_PHARMACY(this.props.pharmacyDetails.id)}>
                                            {strings.Edit_pharmacy}
                                            <i className="fa fa-chevron-right ml-2" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-1 align-self-stretch qf-middle-line qf-mb-30" />

                            <div className="col-6">
                                {this.props.pharmacyDetails.serviceType === 'shop'
                                    ? this.generateShopLayout(this.state.loadingSpinner, this.state.editShopURL)
                                    : this.generateServiceLayout()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PharmacyDetails);



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/component-pharmacy-details.js